var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('h6',{staticClass:"text-weight-regular q-my-md"},[_vm._v("Payment method")]),_c('PaymentMethodSelected'),_c('PaymentForm'),_c('PaymentAmount')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }